<template>
  <footer class="footer">
    <div class="container-fluid">

      <div class="copyright pull-right">
        <span>&copy; 2018 <a href="https://www.freelancedevelopercoach.com" target="_blank">Freelance Developer Coach</a></span>
      </div>
    </div>
  </footer>
</template>
<script>
  export default {}

</script>
<style>

</style>
